
import Vue, { PropType } from 'vue';
import Api from '@/core/api';
import IconButton from '@/common/icon-button/IconButton.vue';
import { Icon } from '@/common/icon/Icon.vue';
import { Handler, Unsubscriber } from '@/core/event-bus';
import { isFunction } from 'lodash';

export default Vue.extend({
    components: {
        IconButton
    },

    props: {
        api: {
            type: Object as PropType<Api>,
            required: true,
        },
        labels: {
            type: Object as PropType<Record<string, unknown>>,
            default: () => ({})
        },
        isLeft: {
            type: Boolean as PropType<boolean>,
            default: false
        }
    },

    data() {
        return {
            isClientFullscreen: false,
            unsubscribers: [] as Unsubscriber[]
        };
    },

    computed: {
        icon(): Icon {
            return this.isClientFullscreen ? Icon.minimize : Icon.maximize;
        }
    },

    mounted() {
        const handler: Handler = (payload, context?) => {
            if (context === 'clientFullscreen') {
                this.isClientFullscreen = payload as boolean;
            }
        };

        const unsubscriber = this.api.onClientAction(handler);

        this.unsubscribers.push(unsubscriber);
    },

    beforeDestroy() {
        for (const unsubscriber of this.unsubscribers) {
            if (isFunction(unsubscriber)) {
                unsubscriber();
            }
        }
    },

    methods: {
        toggleFullScreen() {
            this.api.customAction(null, 'clientFullscreen');
        }
    }
});
